import client from '../../../vendor/rshop/frontend/assets/js/common/client'

const $ = window.jQuery;

export function initRecommendationForm() {
    $('.js-form-recommendation').validate({
        submitHandler: function(form) {
            Form.ajaxPost(form, function(data) {
                $('.js-recommendation-msg')
                    .removeClass('c-msg--success c-msg--error is-hidden')
                    .text((typeof data.msg.format !== 'undefined') ? data.msg.format : data.msg)

                if (data.status) {
                    $('.js-recommendation-msg')
                        .addClass('c-msg--success no_margin')
                        .slideDown();

                    $('.js-form-recommendation').hide();
                } else {
                    $('.js-recommendation-msg')
                        .addClass('c-msg--error')
                        .slideDown();
                }
            }, 'json');
        }
    });
}
